import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from '../_FindAnIndependantFinancialAdviser.scss'
import * as commonStyles from '../../../common/_common.scss'
import { Row, Col, Modal } from 'react-bootstrap'
import AdviserNameSearch from '../../../common/Layout/AdviserNameSearch'
import close from './close.svg'
import { fetchEmailRateLimiter } from '../../AdministrationPortal/Configurations/ConfigureRateLimiter/ConfigureRateLimiterActions'
import 'bootstrap/dist/css/bootstrap.min.css';

class Heading extends React.Component {
  static propTypes = {
    pageSize: PropTypes.number.isRequired,
    emailRateLimit: PropTypes.number.isRequired,
    fetchEmailRateLimiter: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)
    this.state = {
      mobileModal: false
    }
    this.hideMobileModal = this.hideMobileModal.bind(this)
    this.showMobileModal = this.showMobileModal.bind(this)
  }

  componentDidMount () {
    this.props.fetchEmailRateLimiter()
  }

  hideMobileModal (event) {
    this.setState({ mobileModal: false })
    if (event) {
      event.preventDefault()
    }
  }

  showMobileModal (event) {
    this.setState({ mobileModal: true })
  }

  render () {
    const { emailRateLimit } = this.props
    const termsMessage = 'terms of use.'

    return (
      <Row className={commonStyles['bg-white']}>
        <Col xs={12} sm={12} md={12} lg={12}>
          <section className={styles['padding-faifa']}>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <h2>Find an independent financial adviser</h2>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={{ span: 10, offset: 1}} md={{ span: 8, offset: 2 }} lg={{ span: 8, offset: 2 }}>
                <p className={styles['big']}>
                  This service is to help you find an independent financial adviser that can offer you tailored, holistic financial advice based on your requirements. Allan Gray does not give advice and does not employ financial advisers.
                  Need to know more? See our{' '}
                  <a className={styles['terms-of-use-message']} href='https://www.allangray.co.za/faq/#15'>
                    frequently asked questions
                  </a>{' '}
                  about independent financial advice.
                  <br />
                  <br />
                  All the financial advisers listed are registered with the Financial Sector Conduct Authority and are associated with authorised financial services providers. Using this service means you agree to the&nbsp;
                  <a
                    style={{ cursor: 'pointer' }}
                    onClick={this.showMobileModal}
                    className={styles['terms-of-use-link']}
                  >
                    <span className={styles['terms-of-use-message']}>{termsMessage}</span>
                  </a>
                  <br />
                  <br />
                  Please complete the below inputs to personalise your search
                  <br />
                  Contact requests are limited to a maximum of {emailRateLimit} requests per user per day
                </p>
                <AdviserNameSearch pageSize={this.props.pageSize} placeHolder={'Looking for a specific adviser?'} />
                <p className={styles['big-no-bottom']}>
                  Help us show you independent financial advisers that meet your specific financial needs by providing the following information.
                </p>
              </Col>
            </Row>
          </section>
        </Col>

        <Modal show={this.state.mobileModal || this.state.showPopover || this.state.clickShowPopover} className={styles['mobile-modal']}>
          <Modal.Body onClick={this.hideMobileModal}>
            <a onClick={(event) => this.hideMobileModal(event)} href='#' className={styles['close-anchor']}>
              <img src={close} height={25} width={25} />
            </a>
            <h3>terms of use</h3>
            <p>
              The details of the financial advisers provided are for information purposes only and do not amount to an endorsement by Allan Gray. Allan Gray will not be responsible for any false, incorrect or outdated information provided by financial advisers on their profiles. Allan Gray will not be held liable for any loss or damage arising as a direct or indirect result of the use of this webpage or the advice provided by any financial adviser listed.
            </p>
          </Modal.Body>
        </Modal>
      </Row>
    )
  }
}

const mapStateToProps = (state) => ({
  emailRateLimit: state.configureRateLimiterContainer.emailRateLimiter
})

const mapDispatchToProps = {
  fetchEmailRateLimiter
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, commonStyles)(Heading))
